import React from 'react'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import { Box, Chip, Skeleton } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentStyle, setCurrentStyle } from '../../../actions/discoverSlice'

const LeftItem = styled(Paper)(({ theme }) => ({
    backgroundColor: '#ffffff00',
    padding: '16px',
    textAlign: 'center',
    color: theme.palette.text.secondary,
    borderRadius: '16px',
    borderTop: '1px solid #08082F',
}))

interface StylesCardProps {
    discoverData: any,
    handleClose: any
}

const StylesCard = ({discoverData, handleClose}: StylesCardProps) => {
    const dispatch = useDispatch()
    const selectedStyle = useSelector(selectCurrentStyle)

    const fetchedStyles = discoverData?.chart_styles 

    const updateCurrentStyle = (ID: any) => {
        dispatch( setCurrentStyle(ID) )
        if (handleClose)
            handleClose()
    }

    return (
        <LeftItem sx={{textAlign: 'left'}}>
            <Box sx={{ height: {xs: '100%', lg: '90%'}, overflow: 'hidden', overflowY: 'scroll', scrollbarWidth: 'none', marginTop: {xs:0, lg: '16px'}}}>
                {
                    fetchedStyles && fetchedStyles.length > 0
                    ? [...fetchedStyles].sort((a,b) => {
                        if (a.apple_name < b.apple_name) {
                            return -1;
                        }
                        if (a.apple_name > b.apple_name) {
                            return 1;
                        }
                        return 0;
                        }).sort((a,b) => {
                            if (a.apple_id+"" === '34' || b.apple_id+'' === '34') {
                                return -1
                            }
                            return 0
                        })
                        .map((style, key) =>
                            <Chip 
                                key={key}
                                label={style.apple_id === '34' ? 'Général' : style.apple_name} 
                                sx={{ 
                                    color: style.apple_id+"" === selectedStyle+"" ? '#ffffff' : '#7C7CCF',
                                    fontWeight: style.apple_id+"" === selectedStyle+"" ? '800' : '600',
                                    backgroundColor: style.apple_id+"" === selectedStyle+"" ? colorForGenre(style.apple_id) : '#00000080',
                                    borderRadius: '24px',
                                    fontFamily: 'Montserrat',
                                    padding: '8px',
                                    fontSize: '1.4rem',
                                    marginRight: '8px',
                                    marginBottom: '16px',
                                    '& span': {padding: '16px'},
                                    '&:hover': {
                                        color: style.apple_id+"" !== selectedStyle+"" ? '#ffffff' : '#7C7CCF',
                                        backgroundColor: style.apple_id+"" !== selectedStyle+"" ? colorForGenre(style.apple_id) : 'none',
                                    }
                                    }}
                                onClick={() => updateCurrentStyle(style.apple_id)}
                            />
                        )
                    : 
                        <Skeleton />
                }
            </Box>
        </LeftItem>
    )
}

export default StylesCard


const colorForGenre = (genre: string) => {
    switch (genre) {
        case '50000066': return '#084A8A'; // Bleu plus clair
        case '50000064': return '#4A088A'; // Violet
        case '100051': return '#2E0860'; // Violet plus foncé
        case '1229': return '#60084A'; // Magenta foncé
        case '1228': return '#330033'; // Aubergine profond
        case '1227': return '#8A0808'; // Rouge foncé
        case '1225': return '#088A08'; // Vert foncé
        case '1223': return '#A31919'; // Rouge brique
        case '1221': return '#19A319'; // Vert émeraude
        case '1153': return '#6AD46A'; // Vert menthe (Proche de votre ancien vert)
        case '55': return '#7D7DFA';   // Très clair, pervenche (Proche de votre ancien cyan)
        case '51': return '#FFA500';   // Orange (Proche de votre ancien orange/rouge)
        case '34': return '#ADD8E6';   // Bleu clair (Proche de votre ancien bleu-vert)
        case '30': return '#040445';   // Plus foncé (Variation de votre bleu principal)
        case '29': return '#1010A3';   // Plus clair (Variation de votre bleu principal)
        case '28': return '#2121C4';   // Encore plus clair (Variation de votre bleu principal)
        case '27': return '#4747D1';   // Beaucoup plus clair, lavande
        case '24': return '#B0B0FF';   // Presque blanc, teinte bleutée
        case '22': return '#8A8A08';   // Complémentaire directe - Vert olive foncé
        case '21': return '#B3B324';   // Complémentaire plus claire
        case '20': return '#084A8A';   // Bleu plus clair (Similaire à votre ancien bleu)
        case '19': return '#D9D94A';   // Complémentaire encore plus claire (Pour remplacer le magenta vif)
        case '18': return '#4A088A';   // Violet
        case '17': return '#FFD700';   // Or (Proche de votre ancien jaune)
        case '16': return '#A31919';   // Rouge brique (Proche de votre ancien rouge)
        case '15': return '#2E0860';   // Violet plus foncé
        case '14': return '#60084A';   // Magenta foncé (Similaire à votre ancien violet)
        case '12': return '#330033';   // Aubergine profond
        case '11': return '#19A319';   // Vert émeraude (Similaire à votre ancien bleu-vert)
        case '10': return '#088A08';   // Vert foncé
        case '8': return '#4A088A';    // Violet (Similaire à votre ancien violet)
        case '7': return '#60084A';    // Magenta foncé (Similaire à votre ancien violet)
        case '6': return '#E6E6FA';    // Lavande (Proche de votre ancien gris-rose)
        case '5': return '#D3D3D3';    // Gris clair (Pour remplacer l'autre gris-rose)
        case '4': return '#084A8A';    // Bleu plus clair
        case '2': return '#FFD700';    // Or (Proche de votre ancien jaune)

        default:return '#08088A'; // Votre couleur de base
    }
}
